import React, {PureComponent, Fragment} from 'react';
import PropTypes from 'prop-types';
import Textfield from '@atlaskit/textfield';
import styled from 'styled-components';
import Textarea from '@atlaskit/textarea';
import FieldSelect from './FieldSelect';
import FieldSortSelect from './FieldSortSelect';
import DynamicTable from '@atlaskit/dynamic-table';
import {ToggleStateless} from '@atlaskit/toggle';
import Button from '@atlaskit/button';
import Select from '@atlaskit/select';
import EditorCloseIcon from '@atlaskit/icon/glyph/editor/close';
import EditorAddIcon from '@atlaskit/icon/glyph/editor/add';
import {DatePicker, DateTimePicker} from '@atlaskit/datetime-picker';
import Spinner from '@atlaskit/spinner';
import { Trans } from 'react-i18next';
import { Checkbox } from '@atlaskit/checkbox';

const FieldLabel = styled.label`
  font-size: 0.8571428571428571em;
  font-style: inherit;
  line-height: 1.3333333333333333;
  color: #6B778C;
  font-weight: 600;
  margin-top: 16px;
  display: inline-block;
  margin-bottom: 4px;
  margin-top: 12px;
`
const FieldRequired = styled.span`
  color: #DE350B;
  padding-left: 2px;
`
const FieldLimit = styled.div`
  text-align: right;
  font-size: 8px;
  color: #6B778C;
`;

export const FormSection = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: #172B4D;
  margin-bottom: 8px;
  margin-top: 16px;
`

export class FieldWrapper extends PureComponent {
  static propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    required: PropTypes.bool,
    children: PropTypes.node
  };

  render() {
    const {
      name,
      label,
      required,
      children,
    } = this.props;
    
    return (
      <Fragment>
        <FieldLabel htmlFor={name}>
          {label}
          {required && <FieldRequired>*</FieldRequired>}
        </FieldLabel>
        {children}
      </Fragment>
    );
  }
}

export class TextField extends PureComponent {
  static propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    required: PropTypes.bool,
  };

  render() {
    const {
      name,
      label,
      required,
      onChange,
      ...otherProps
    } = this.props;
    
    return (
      <FieldWrapper
        name={name}
        label={label}
        required={required}>
        <Textfield
          name={name}
          autoComplete='off'
          isRequired={required}
          onChange={e => onChange(name, e.target.value)}
          {...otherProps}
        />
        {otherProps.maxLength && (
          <FieldLimit>
            {otherProps.value ? otherProps.value.length : 0}/{otherProps.maxLength}
          </FieldLimit>
        )}
      </FieldWrapper>
    );
  }
}

export class DatePickerField extends PureComponent {
  static propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    required: PropTypes.bool,
  };
  /* react-select-${name}-input - теперь не устанавливается value*/
  componentDidMount() {
    const {
      name,
      required,
    } = this.props;

    if (required) {
      const input = document.getElementsByName(name);
      //const input = document.getElementById(`react-select-${name}-input`);
      if (input && input.length && input[0]) {
        input[0].setAttribute("required", "");
        input[0].style.opacity = 0;
        input[0].style.width = "0px";
        input[0].style.height = "0px";
        input[0].style.float = "left";
        input[0].style.margin = "0px";
        input[0].style.padding = "0px";
        input[0].setAttribute("type", "text");
      }
    }
  }
  render() {
    const {
      name,
      label,
      required,
      onChange,
      ...otherProps
    } = this.props;
    
    return (
      <FieldWrapper
        name={name}
        label={label}
        required={required}>
        <DatePicker
          id={name}
          name={name}
          valueDefault={null}
          locale='ru'
          onChange={value => onChange(name, value)}
          {...otherProps}
        />
      </FieldWrapper>
    );
  }
}


export class DateTimePickerField extends PureComponent {
  static propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    required: PropTypes.bool,
  };
  /* react-select-${name}-input - теперь не устанавливается value*/
  componentDidMount() {
    const {
      name,
      required,
    } = this.props;

    if (required) {
      const input = document.getElementsByName(name);
      //const input = document.getElementById(`react-select-${name}-input`);
      if (input && input.length && input[0]) {
        input[0].setAttribute("required", "");
        input[0].style.opacity = 0;
        input[0].style.width = "0px";
        input[0].style.height = "0px";
        input[0].style.float = "left";
        input[0].style.margin = "0px";
        input[0].style.padding = "0px";
        input[0].setAttribute("type", "text");
      }
    }
  }
  render() {
    const {
      name,
      label,
      required,
      onChange,
      ...otherProps
    } = this.props;
    
    return (
      <FieldWrapper
        name={name}
        label={label}
        required={required}>
        <DateTimePicker
          id={name}
          name={name}
          valueDefault={Date.now()}
          locale='ru'
          onChange={value => onChange(name, value)}
          {...otherProps}
        />
      </FieldWrapper>
    );
  }
}

export class TextAreaField extends PureComponent {
  static propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    required: PropTypes.bool,
  };

  render() {
    const {
      name,
      label,
      required,
      onChange,
      ...otherProps
    } = this.props;
    
    return (
      <FieldWrapper
        name={name}
        label={label}
        required={required}
      >
        <Textarea
          name={name}
          isRequired={required}
          onChange={e => onChange(name, e.target.value)}
          {...otherProps}
        />
        {otherProps.maxLength && (
          <FieldLimit>
            {otherProps.value ? otherProps.value.length : 0}/{otherProps.maxLength}
          </FieldLimit>
        )}
      </FieldWrapper>
    );
  }
}

export class SelectField extends PureComponent {
  static propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    required: PropTypes.bool,
  };
  /* Не работает
  componentDidMount() {
    const {
      name,
      required,
    } = this.props;
    if (required) {
      const input = document.getElementsByName(name);
      console.log("select", input, input.length, input[0]);
      if (input && input.length && input[0]) {
        input[0].setAttribute("required", "");
        input[0].style.opacity = 0;
        input[0].style.width = "0px";
        input[0].style.height = "0px";
        input[0].style.float = "left";
        input[0].style.margin = "0px";
        input[0].style.padding = "0px";
        input[0].setAttribute("type", "text");
        console.log("select / set hidden");
      }
    }
  }
  */
  render() {
    const {
      name,
      label,
      required,
      ...otherProps
    } = this.props;
    
    return (
      <FieldWrapper
        name={name}
        label={label}
        required={required}
      >
        <FieldSelect
          {...otherProps}
          name={name}
          required={required}
          keyName={name}
        />
      </FieldWrapper>
    );
  }
}

export class SortSelectField extends PureComponent {
  static propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    required: PropTypes.bool,
  };

  render() {
    const {
      name,
      label,
      required,
      ...otherProps
    } = this.props;
    
    return (
      <FieldWrapper
        name={name}
        label={label}
        required={required}
      >
        <FieldSortSelect
          {...otherProps}
          name={name}
          isRequired={required}
          keyName={name}
        />
      </FieldWrapper>
    );
  }
}

export class CheckBoxField extends PureComponent {
  render() {
    const {
      name,
      value,
      label,
      required,
      onChange,
      ...otherProps
    } = this.props;
    
    return (
      <FieldWrapper
        name={name}
        label={label}
        required={required}
      >
        <Checkbox
          {...otherProps}
          name={name}
          onChange={e => onChange(name, e.target.checked)}
          value={value}
          isRequired={required}
          keyName={name}
        />
      </FieldWrapper>
    );
  }
}

export class TableField extends PureComponent {
  static propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    required: PropTypes.bool,
    fields: PropTypes.array,
    operators: PropTypes.array,
    andOr: PropTypes.array,
    getDictionaries: PropTypes.func,
    disabled: PropTypes.bool,
  };

  componentDidMount() {
    const {fields, operators, andOr, getDictionaries} = this.props;
    
    if (!fields) {
      getDictionaries('fields');
    }
    if (!operators) {
      getDictionaries('operators');
    }
    if (!andOr) {
      getDictionaries('andOr');
    }
  }

  onFieldChange = data => {
    const {onChange, name} = this.props;
    onChange(name, data);
  }

  addRow = () => {
    const {value, fields, operators, andOr} = this.props;
    const items = [...value];
    items.push({
      andOr: andOr[0].id,
      fieldName: fields[0].id,
      operator: operators[0].id,
      value: '',
    })
    this.onFieldChange(items);
  }

  removeRow = index => {
    const {value} = this.props;
    let items = [...value];
    items.splice(index, 1);
    this.onFieldChange(items);
  }

  onChangeRow = (index, obj) => {
    const {value} = this.props;
    let items = [...value];
    items[index] = obj;
    this.onFieldChange(items);
  }

  buildRows = data => {
    const {fields, andOr, operators, disabled} = this.props;
    let rows = data.map((item, index) => {
      const field = fields.find(f => f.id === item.fieldName);
      return ({
        key: `row-${index}-${item.id}`,
        cells: [
          {content: index === 0 ? null : (
            <Select
              isDisabled={disabled}
              getOptionLabel={({name}) => name}
              getOptionValue={({id}) => id}
              value={andOr.find(itm => itm.id === item.andOr)}
              options={andOr}
              onChange={({id}) => this.onChangeRow(index, {...item, andOr: id})}
            />
          )},
          {content: (
            <Select
              isDisabled={disabled}
              getOptionLabel={({name}) => name}
              getOptionValue={({id}) => id}
              value={field}
              options={fields}
              onChange={({id}) => this.onChangeRow(index, {...item, fieldName: id, value: ''})}
            />
          )},
          {content: (
            <Select
              isDisabled={disabled}
              getOptionLabel={({name}) => name}
              getOptionValue={({id}) => id}
              value={operators.find(o => o.id === item.operator)}
              options={operators}
              onChange={({id}) => this.onChangeRow(index, {...item, operator: id})}
            />
          )},
          {content: (
            <div style={{display: 'flex'}}>
              <div style={{flexGrow: 1}}>
                {{
                  bool: (
                    <ToggleStateless
                      isDisabled={disabled}
                      isChecked={item.value}
                      size='large'
                      onChange={e => this.onChangeRow(index, {...item, value: !item.value})}
                    />
                  ),
                  date: (
                    <DatePicker
                      isDisabled={disabled}
                      locale='ru'
                      value={item.value}
                      onChange={value => this.onChangeRow(index, {...item, value})}
                    />
                  ),
                }[field.type] || (
                  <Textfield
                    isDisabled={disabled}
                    value={item.value}
                    type={field.type}
                    onChange={e => this.onChangeRow(index, {...item, value: e.target.value})}
                  />
                )}
              </div>
              <Button
                appearance='subtle'
                spacing='none'
                iconBefore={<EditorCloseIcon primaryColor='red' />}
                onClick={() => this.removeRow(index)}
                isDisabled={disabled}
              />
            </div>
          )},
      ]})
    });
    rows = [...rows]; // the data is mutable and we can't use push below.
    rows.push(
      {
        key: `row-${rows.length}-add`,
        cells: [
          {
            colSpan: 4,
            content: (
              <Button
                isDisabled={disabled}
                appearance='subtle'
                iconBefore={<EditorAddIcon />}
                onClick={() => this.addRow()}
              >
                <Trans>Add condition</Trans>
              </Button>
            ),
          }
        ]
      }
    );
    return rows;
  };

  render() {
    const {
      name,
      label,
      required,
      value,
      fields,
      operators,
      andOr,
    } = this.props;

    return (
      <FieldWrapper
        name={name}
        label={label}
        required={required}
      >
        {fields && operators && andOr ? (
          <Fragment>
          <DynamicTable
            head={head}
            rows={this.buildRows(value)}
            rowsPerPage={undefined}
            defaultPage={1}
          />
          </Fragment>
        ) : (
          <div>
            <Spinner />
          </div>
        )}
      </FieldWrapper>
    );
  }
}

const head = {
  cells: [
    {
      key: 'andOr',
      content: <Trans>AND/OR</Trans>,
      isSortable: false,
      width: '80px',
    },
    {
      key: 'fieldName',
      content: <Trans>Field</Trans>,
      isSortable: false,
      width: undefined,
    },
    {
      key: 'operator',
      content: <Trans>Operator</Trans>,
      isSortable: false,
      width: '140px',
    },
    {
      key: 'value',
      content: <Trans>Value</Trans>,
      isSortable: false,
      width: '220px',
    }
  ],
};
